
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USUARIO = 'GET_USUARIO';
export const SET_CONFIGURACION = 'GET_CONFIGURACION';
export const SET_FECHASFILTRO = 'SET_FECHASFILTRO';

